import type { ActivityItem } from "@typings/index";

export const activities: ActivityItem[] = [
  {
    id: 1,
    name: "Milford Sound Cruise",
    description:
      "Experience the breathtaking beauty of Milford Sound with a scenic cruise through pristine fiord landscapes, cascading waterfalls, and diverse wildlife including seals, dolphins, and penguins.",
    category: ["Nature", "Scenic"],
    duration: "2 hours",
    price: 89,
    image: "/assets/milford-sound-cruise.jpg",
    location: "Milford Sound, South Island",
    included: [
      "Guided commentary",
      "Refreshments",
      "Wildlife viewing",
      "Photo stops",
    ],
    link: "https://www.milford-sound.co.nz/",
  },
  {
    id: 2,
    name: "Hobbiton Movie Set Tour",
    description:
      "Step into the magical world of Middle-earth with a guided tour of the Hobbiton Movie Set. See the Hobbit Holes, The Green Dragon Inn, and the Party Tree.",
    category: ["Cultural", "Sightseeing"],
    duration: "2.5 hours",
    price: 95,
    image: "/assets/hobbit-house.jpg",
    location: "Waikato, North Island",
    included: [
      "Guided tour",
      "Complimentary beverage",
      "Photo opportunities",
      "Behind the scenes stories",
    ],
    link: "https://www.hobbitontours.com/",
  },
  {
    id: 3,
    name: "Agrodome Farm Experience",
    description:
      "Experience New Zealand's most popular farm experience with a guided tractor trailer tour of a working 350 acre farm. Hand feed the friendly lambs, watch a sheep shearing demonstration, and visit the farmyard nursery.",
    category: ["Cultural", "Wildlife"],
    duration: "3 hours",
    price: 89,
    image: "/assets/agrodome-tractor-tour.jpg",
    location: "Rotorua, North Island",
    included: [
      "Farm Show admission",
      "Guided tractor trailer tour",
      "Animal feeding",
      "Farmyard Nursery access",
      "Photo opportunities",
    ],
    link: "https://www.agrodome.co.nz/",
  },
  {
    id: 4,
    name: "Waitomo Glowworm Caves",
    description:
      "Magical underground boat tour through the Waitomo Glowworm Caves, illuminated by thousands of tiny glowworms creating a starry wonderland.",
    category: ["Adventure", "Nature"],
    duration: "45 minutes",
    price: 55,
    image: "/assets/waitomo-glowworm.jpg",
    location: "Waikato, North Island",
    included: [
      "Boat tour",
      "Guided commentary",
      "Cave exploration",
      "Educational information",
    ],
    link: "https://www.waitomo.com/glowworms-and-caves/waitomo-glowworm-caves",
  },
  {
    id: 5,
    name: "Queenstown Bungy Jump",
    description:
      "Experience the ultimate adrenaline rush with a bungy jump from the iconic Kawarau Bridge, the world's first commercial bungy site.",
    category: ["Adventure"],
    duration: "2 hours",
    price: 205,
    image: "/assets/bungy-queenstown.jpg",
    location: "Queenstown, South Island",
    included: [
      "Safety briefing",
      "Jump certificate",
      "T-shirt",
      "Photos/videos available",
    ],
    link: "https://www.bungy.co.nz/queenstown/",
  },
  {
    id: 6,
    name: "Rotorua Skyline Gondola & Luge",
    description:
      "Experience the iconic Skyline Rotorua with a scenic gondola ride up and take in the views of Rotorua from the top. Enjoy the luge rides, or try other activities like the zipline and skyswing.",
    category: ["Adventure", "Sightseeing"],
    duration: "3 hours",
    price: 50,
    image: "/assets/rotorua-skyline.jpg",
    location: "Rotorua, North Island",
    included: [
      "Gondola ride",
      "Luge ride",
      "Spectacular views",
      "Zipline",
      "Photo opportunities",
    ],
    link: "https://rotorua.skyline.co.nz/",
  },
  {
    id: 7,
    name: "Redwoods Forest Walk",
    description:
      "Enjoy an awe inspiring walk through the magnificent Whakarewarewa Forest among towering Californian Coastal Redwoods within the beautiful Redwood Grove.",
    category: ["Nature", "Sightseeing"],
    duration: "1 hour",
    price: 0,
    image: "/assets/rotorua-redwood-forest.webp",
    location: "Rotorua, North Island",
    included: [
      "Free forest access",
      "Walking tracks",
      "Redwood Grove views",
      "Photo opportunities",
      "Map access",
    ],
    link: "https://redwoods.co.nz/walk/short-walks/",
  },
  {
    id: 8,
    name: "High Country Salmon Farm",
    description:
      "Experience a working salmon farm in the pristine waters of the High Country. Feed the fish or try your hand at catching salmon straight from the canals.",
    category: ["Cultural", "Wildlife"],
    duration: "2 hours",
    price: 0,
    image: "/assets/high-country-salmon.webp",
    location: "Twizel, South Island",
    included: [
      "Free fish feeding",
      "Salmon farm viewing",
      "Educational talks",
      "Floating cafe access",
      "Photo opportunities",
    ],
    link: "https://www.highcountrysalmon.co.nz/pages/farm-experiences",
  },
  {
    id: 9,
    name: "Cornwall Park Visit",
    description:
      "Explore Auckland's cherished urban oasis, rich with history, nature, farm life and places to discover. Enjoy this free greenspace with walking trails, working farm views, and peaceful picnic areas.",
    category: ["Nature", "Sightseeing"],
    duration: "2 hours",
    price: 0,
    image: "/assets/cornwall-park.jpg",
    location: "Auckland, North Island",
    included: [
      "Free entry",
      "Walking trails",
      "Farm animal viewing",
      "Historic sites",
      "Picnic areas",
    ],
    link: "https://cornwallpark.co.nz/",
  },
  {
    id: 10,
    name: "Whakarewarewa living Maori Village",
    description:
      "Immerse yourself in Maori culture with traditional cultural performances, geothermal wonders, and the way of life of the Maori people.",
    category: ["Cultural"],
    duration: "3 hours",
    price: 75,
    image: "/assets/whakarewarewa-village.webp",
    location: "Rotorua, North Island",
    included: [
      "Cultural performance",
      "Geothermal tour",
      "Arts & crafts demonstration",
      "Hangi feast option",
    ],
    link: "https://whakarewarewa.com/",
  },
  {
    id: 11,
    name: "Punting on the Avon",
    description:
      "Relax and unwind on a scenic 30 minute guided punt ride through central Christchurch. See the flora and wildlife of the picturesque Avon River up close while your classically attired punter shares informative commentary about the sights.",
    category: ["Nature", "Sightseeing"],
    duration: "30 minutes",
    price: 42,
    image: "/assets/punting-on-avon.jpg",
    location: "Christchurch, South Island",
    included: [
      "Guided punt ride",
      "Informative commentary",
      "Blankets and umbrellas if needed",
      "Photo opportunities",
    ],
    link: "https://www.christchurchattractions.nz/punting/",
  },
  {
    id: 12,
    name: "Whakapapa Ski Field",
    description:
      "Experience world class skiing and snowboarding on Mt Ruapehu with 550 hectares of terrain. From gentle learner slopes in Happy Valley to advanced free ride terrain, plus sledding areas for families.",
    category: ["Adventure", "Scenic"],
    duration: "4 hours",
    price: 135,
    image: "/assets/whakapapa-ski-field.jpg",
    location: "Mount Ruapehu, North Island",
    included: [
      "All mountain day pass",
      "Access to chairlifts",
      "Beginner to advanced terrain",
      "Sledding areas",
      "Mountain restaurant access",
    ],
    link: "https://www.whakapapa.com/",
  },
  {
    id: 14,
    name: "Auckland War Memorial Museum",
    description:
      "Explore New Zealand's story at Auckland Museum, featuring Māori collections, natural history resources, military history collections, and decorative arts.",
    category: ["Cultural", "Museum"],
    duration: "2 hours",
    price: 27,
    image: "/assets/auckland-museum.jpg",
    location: "Auckland, North Island",
    included: [
      "Museum entry",
      "Interactive exhibits",
      "Natural history displays",
      "War memorial galleries",
    ],
    link: "https://www.aucklandmuseum.com/",
  },
  {
    id: 15,
    name: "Westhaven Marina & Viaduct Harbour",
    description:
      "Explore Auckland's maritime heart with a visit to Westhaven Marina, the largest recreational marina in the Southern Hemisphere, then stroll to the picturesque Viaduct Harbour surrounded by restaurants and cafes. Enjoy waterfront walks, and experience Auckland's vibrant maritime atmosphere.",
    category: ["Sightseeing"],
    duration: "3 hours",
    price: 0,
    image: "/assets/viaduct-harbour.jpeg",
    location: "Auckland, North Island",
    included: [
      "Free entry",
      "Waterfront walking paths",
      "Marina and harbour viewing",
      "Restaurant and cafe access",
      "Photo opportunities",
      "New Zealand Maritime Museum nearby",
    ],
    link: "https://www.aucklandnz.com/explore/viaduct-waterfront",
  },
  {
    id: 16,
    name: "Huka Falls Visit",
    description:
      "Enjoy walking tracks along both sides of Huka Falls where nearly a quarter of a million litres of water per second erupts from a natural gorge and thunders 11m into the Waikato River. ",
    category: ["Nature", "Sightseeing"],
    duration: "1 hour",
    price: 0,
    image: "/assets/huka-falls.webp",
    location: "Taupo, North Island",
    included: [
      "Free viewing access",
      "Walking tracks",
      "Multiple viewing angles",
      "Photo opportunities",
      "Picnic areas",
    ],
    link: "https://www.lovetaupo.com/en/discover/highlights/huka-falls/",
  },
  {
    id: 17,
    name: "Queenstown Skyline Gondola & Luge",
    description:
      "Experience the steepest gondola in the Southern Hemisphere, carrying you 480 metres above Queenstown and Lake Wakatipu to the top of Bob's Peak. Enjoy breathtaking views of the Remarkables mountain range and thrilling luge rides down the mountain side.",
    category: ["Adventure", "Scenic", "Sightseeing"],
    duration: "3 hours",
    price: 52,
    image: "/assets/queenstown-skyline.webp",
    location: "Queenstown, South Island",
    included: [
      "Return gondola ride",
      "Luge ride",
      "Spectacular viewing platform",
      "Access to mountain biking trails",
      "Photo opportunities",
    ],
    link: "https://queenstown.skyline.co.nz/",
  },
  {
    id: 18,
    name: "Huka Falls Jet",
    description:
      "Experience jet boating on the Waikato River at speeds up to 80km/h. Enjoy thrilling 360 degree spins and get closer than anyone else to the spectacular Huka Falls.",
    category: ["Adventure"],
    duration: "30 minutes",
    price: 139,
    image: "/assets/huka-falls-jet.jpg",
    location: "Taupo, North Island",
    included: [
      "30 minute jet boat ride",
      "Safety briefing",
      "Life jacket",
      "Expert driver commentary",
      "Photo opportunities",
    ],
    link: "https://www.hukafallsjet.com/",
  },
];
